import { listOptions } from '@/febos/servicios/api/opciones.api';

export default {
  data() {
    return {
      documents: [],
      referencesDocs: []
    };
  },
  methods: {
    findLabelDocument(typeDocument) {
      const documents = this.documents.concat(this.referencesDocs);
      const typeDoc = documents.find((doc) => doc.valor === typeDocument);
      return typeDoc ? typeDoc.descripcion : '-';
    }
  },
  async created() {
    // FIXME:  const { data } = await clOpcionesEmpresaList({  Hay que ver esto
    const { data } = await listOptions({
      grupoOpcion: 'tipos-referencias-documentos',
      deshabilitado: 'no'
    });
    this.documents = data.opciones;
    // FIXME:  const { data } = await clOpcionesEmpresaList({  Hay que ver esto
    const response = await listOptions({
      grupoOpcion: 'tipos.documentos-ed',
      deshabilitado: 'no',
      agrupar: 'si'
    });
    this.referencesDocs = response.data.opciones;
  }
};
